import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pp-lottery-winnings pp-lottery-winnings--centered" }
const _hoisted_2 = ["innerHTML"]

import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-stastne-datum-winnings',
  setup(__props) {

const winningOrdersGrid: [string, number][] = [
    ["1 + 1 + 1", 10000],
    ["1 + 0 + 1", 200],
    ["0 + 1 + 1", 50],
    ["1 + 1 + 0", 20],
    ["0 + 0 + 1", 6],
    ["1 + 0 + 0", 2],
    ["0 + 1 + 0", 1],
];

const formatMultiple = (multiple: number) => `${StringUtils.formatNumber(multiple)}x`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DsTable, null, {
      default: _withCtx(() => [
        _createVNode(DsRow, null, {
          default: _withCtx(() => [
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Výherní pořadí")
              ])),
              _: 1,
              __: [0]
            }),
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Uhodnuto (D+M+R)")
              ])),
              _: 1,
              __: [1]
            }),
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Výherní násobek")
              ])),
              _: 1,
              __: [2]
            })
          ]),
          _: 1
        }),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(winningOrdersGrid, (order, index) => {
          return _createVNode(DsRow, { key: index }, {
            default: _withCtx(() => [
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(index + 1) + ". pořadí", 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(order[0]), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("strong", {
                    innerHTML: formatMultiple(order[1])
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        }), 64))
      ]),
      _: 1
    })
  ]))
}
}

})